export const PaymentLabelTextHelper = {
    getLabelText: {
        paymentId: 'Payment ID',
        datePaymentOn: 'Payment Date',
        dateOrderOn: 'Order Date',
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        paymentType: 'Payment Type',
        balanceType: 'Balance Type',
        paymentAmount: 'Payment Amount',
        paymentCurrencyCode: 'Payment Currency',
        description: 'Description',
        remarks: 'Remarks',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        datePaymentOnFrom: 'Payment Date From',
        datePaymentOnTo: 'Payment Date To',
        action: 'Action'
    }
};
